/** The shop's bot (@coins_rubot) — single source for Telegram deep links. */
export const BOT_USERNAME = 'coins_rubot'

/**
 * Deep link that re-opens a chat INSIDE the Telegram Mini App.
 *
 * Why this exists: after paying through WATA the buyer lands back in the
 * external browser (SBP/bank app), where the mini-app session cookie does not
 * exist. A plain /chat/<id> link there hits the login wall, which reads as
 * «оплатил — чат не открывается». `/start chat_<id>` opens the bot, whose
 * reply is a web_app button — that launches the mini app with fresh initData,
 * auto-login runs, and the chat opens for its owner.
 */
export function telegramChatLink(chatId: string): string {
  return `https://t.me/${BOT_USERNAME}?start=${encodeURIComponent(`chat_${chatId}`)}`
}
